import React from 'react';
import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';

import Check from '@material-ui/icons/Check';
import Help from '@material-ui/icons/Help';


const styles = theme => ({
    root: {
        boxSizing: 'border-box',
        padding: '24px',
        width: '100%'
    },
    title: {
        textAlign: 'center',
        marginBottom: '32px',
        fontWeight: 500
    },
    cards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '12px',
        justifyContent: 'center'
    },
    card: {
        width: '100%',
        maxWidth: '100%',
        borderTop: `4px solid ${theme.palette.primary.main}`,
        display: 'flex',
        flexDirection: 'column'
    },
    planTitle: {
        fontSize: '22px',
        fontWeight: 600,
        marginBottom: '4px'
    },
    subtitle: {
        color: theme.palette.text.secondary,
        fontSize: '14px',
        marginBottom: '16px'
    },
    price: {
        fontSize: '24px',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        marginBottom: '20px'
    },
    feature: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: '10px 0',
        borderBottom: '1px solid #f0f0f0'
    },
    featureMark: {
        minWidth: '28px',
        width: 'auto',
        flexShrink: 0,
        textAlign: 'center',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        whiteSpace: 'nowrap',
        paddingRight: '8px'
    },
    featureNo: {
        color: theme.palette.text.disabled
    },
    featureText: {
        flex: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '6px',
        paddingLeft: '4px'
    },
    helpButton: {
        padding: '2px',
        color: '#fff',
        backgroundColor: theme.palette.primary.main,
        width: '20px',
        height: '20px',
        minWidth: '20px',
        borderRadius: '50%',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark
        },
        '& svg': {
            fontSize: '14px'
        }
    },
    selectButton: {
        marginTop: 'auto',
        padding: '12px',
        border: `2px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff'
        }
    }
});


const plans = [
    {
        id: 'novice',
        title: 'Новичок',
        subtitle: 'Игра для своих',
        price: 'Бесплатно'
    },
    {
        id: 'specialist',
        title: 'Специалист',
        subtitle: 'Квиз без геолокации',
        price: '290₽ / игра'
    },
    {
        id: 'specialist_plus',
        title: 'Специалист+',
        subtitle: 'Квиз для всех городов',
        price: '4900₽ / игра'
    },
    {
        id: 'profi',
        title: 'Профи',
        subtitle: 'Публичная игра в каталоге',
        price: '790₽ / игра'
    },
    {
        id: 'expert',
        title: 'Эксперт',
        subtitle: 'Экскурсия с продлением',
        price: '1890₽ / месяц'
    },
    {
        id: 'agency',
        title: 'Агентство',
        subtitle: 'Безлимит на 6 месяцев',
        price: '59990₽ / 6 мес.'
    }
];


const rows = [
    {
        label: 'Квест',
        description: 'С выбором победителей: вы указываете количество, а платформа по окончании указанного времени определяет и выводит список победителей в приложении и в административном интерфейсе автора.',
        values: { novice: 'v', specialist: 'x', specialist_plus: 'x', profi: 'v', expert: 'x', agency: 'v' }
    },
    {
        label: 'Экскурсия',
        description: 'Победители не определяются, игру можно проходить многократно, срок действия — до месяца. Можно продлять согласно стоимости на 30 дней.',
        values: { novice: 'x', specialist: 'x', specialist_plus: 'x', profi: 'x', expert: 'v', agency: 'v' }
    },
    {
        label: 'Квиз',
        description: 'Доступны только задания без геолокации.',
        values: { novice: 'v', specialist: 'v', specialist_plus: 'v', profi: 'x', expert: 'x', agency: 'v' }
    },
    {
        label: 'Срок действия',
        description: 'Максимальная длительность игры/экскурсии или срок подписки.',
        values: { novice: '1 день', specialist: '3 дня', specialist_plus: '30 дней', profi: '7 дней', expert: '30 дней', agency: '6 мес.' }
    },
    {
        label: 'Количество игроков',
        description: 'Максимальное количество слотов для игроков. В тарифах Специалист, Профи и Эксперт — без ограничений.',
        values: { novice: '5', specialist: '∞', specialist_plus: '∞', profi: '∞', expert: '∞', agency: '∞' }
    },
    {
        label: 'Публикация в каталоге',
        description: 'В тарифе Новичок публикация в каталоге недоступна. В тарифах Специалист, Профи и Эксперт — по выбору автора.',
        values: { novice: 'x', specialist: 'v', specialist_plus: 'v', profi: 'v', expert: 'v', agency: 'v' }
    },
    {
        label: 'Сообщение игрокам',
        description: 'Отправка пуш-уведомлений игрокам: например, о переносе даты начала или изменении локации награждения победителей.',
        values: { novice: 'x', specialist: 'v', specialist_plus: 'v', profi: 'v', expert: 'x', agency: 'v' }
    }
];


class GameTariffSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            dialogTitle: '',
            dialogText: '',
            agencyBusy: false
        };
    }

    render() {
        const c = this;
        const { classes, history } = c.props;

        return <div className={classes.root}>
            <Typography variant="h5" className={classes.title}>
                Выберите тариф для новой игры
            </Typography>

            <div className={classes.cards}>
                {plans.map(plan =>
                    <Card key={plan.id} className={classes.card}>
                        <CardContent>
                            <Typography className={classes.planTitle}>
                                {plan.title}
                            </Typography>
                            <Typography className={classes.subtitle}>
                                {plan.subtitle}
                            </Typography>
                            <Typography className={classes.price}>
                                {plan.price}
                            </Typography>

                            {rows.map((row, idx) =>
                                <div key={idx} className={classes.feature}>
                                    <div className={classes.featureMark}>
                                        {c.renderMark(row.values[plan.id])}
                                    </div>
                                    <div className={classes.featureText}>
                                        <span>{row.label}</span>
                                        <IconButton className={classes.helpButton}
                                                    onClick={() => c.openDialog(row.label, row.description)}>
                                            <Help fontSize="small" />
                                        </IconButton>
                                    </div>
                                </div>
                            )}
                        </CardContent>

                        <CardActions>
                            {plan.id === 'agency'
                                ? <Button fullWidth
                                          variant="outlined"
                                          color="primary"
                                          className={classes.selectButton}
                                          disabled={c.state.agencyBusy}
                                          onClick={() => c.handleAgencyPay()}>
                                    {c.state.agencyBusy ? 'Отправка...' : 'Оформить'}
                                </Button>
                                : <Button fullWidth
                                          variant="outlined"
                                          color="primary"
                                          className={classes.selectButton}
                                          onClick={() => history.push(`/admin/game/create?plan=${plan.id}`)}>
                                    Выбрать
                                </Button>
                            }
                        </CardActions>
                    </Card>
                )}
            </div>

            <Dialog open={c.state.dialogOpen}
                    onClose={c.closeDialog.bind(c)}>
                <DialogTitle>{c.state.dialogTitle}</DialogTitle>
                <DialogContent>
                    <Typography>{c.state.dialogText}</Typography>
                </DialogContent>
            </Dialog>
        </div>;
    }

    renderMark(value) {
        const { classes } = this.props;

        if (value === 'v') {
            return <Check fontSize="small" className={classes.featureMark} />;
        }
        if (value === 'x') {
            return <span className={classes.featureNo}>—</span>;
        }
        return <span>{value}</span>;
    }

    handleAgencyPay() {
        const c = this;
        c.setState({ agencyBusy: true });

        fetch('/admin/rest/franchise/pay-subscription', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': (window.Params && window.Params.csrf_token) || ''
            }
        })
            .then(r => r.json())
            .then(json => {
                c.setState({ agencyBusy: false });
                if (json.payment_url) {
                    window.open(json.payment_url, '_blank');
                } else {
                    window.alert(json.message || 'Не удалось получить ссылку на оплату');
                }
            })
            .catch(err => {
                c.setState({ agencyBusy: false });
                window.alert('Ошибка при создании платежа: ' + err.message);
            });
    }

    openDialog(title, text) {
        this.setState({ dialogOpen: true, dialogTitle: title, dialogText: text });
    }

    closeDialog() {
        this.setState({ dialogOpen: false });
    }
}


export default withStyles(styles)(withRouter(GameTariffSelector));
